// QrMenuTvPage.jsx
import React, { useEffect, useState } from "react";
import { collection, query, orderBy, onSnapshot } from "firebase/firestore";
import { db } from "../../firebase";
import "./QrMenuTvPage.css";

import TvSkelleton from "../MenuSkeleton/TvSkelleton";
import { useTvSlideshowEngine } from "../../hooks/useTvSlideshowEngine";
import { useImageLoader } from "../../hooks/useImageLoader";

export default function QrMenuTvPage() {
  const [menu, setMenu] = useState([]);
  const [loading, setLoading] = useState(true);
  const [hideCursor, setHideCursor] = useState(false);
  // Հեռացվել է interImageReady state-ը

  const { getImageProps, preload } = useImageLoader();

  const {
    currentIndex,
    // showInterImage-ը այլևս չենք օգտագործում render-ի մեջ
    imageCache,
    getItemsForCurrentPage,
    loadedImages,
    filteredMenu
  } = useTvSlideshowEngine(menu);

  const currentCategory = filteredMenu[currentIndex];
  const items = getItemsForCurrentPage();

  // 🗑️ Հեռացվել է "Preload interImage" useEffect-ը

  // Fetch menu
  useEffect(() => {
    const q = query(collection(db, "menu"), orderBy("order"));
    const unsubscribe = onSnapshot(q, (snapshot) => {
      const data = snapshot.docs.map((doc) => ({ id: doc.id, ...doc.data() }));
      setMenu(data.filter((item) => item.category?.toUpperCase() !== "SOFT DRINKS"));
      setLoading(false);
    });
    return () => unsubscribe();
  }, []);

  // Preload item images
  useEffect(() => {
    items.forEach((item) => {
      if (item.imageUrl) preload(item.imageUrl);
    });
  }, [items, preload]);

  // Fullscreen toggle
  const handleLogoClick = () => {
    const el = document.documentElement;
    if (!document.fullscreenElement) {
      el.requestFullscreen?.() || el.webkitRequestFullscreen?.() || el.msRequestFullscreen?.();
    } else {
      document.exitFullscreen?.();
    }
  };

  // Hide cursor during fullscreen after 2s inactivity
  useEffect(() => {
    let timer;
    const handleMouseMove = () => {
      if (!document.fullscreenElement) {
        setHideCursor(false);
        return;
      }
      setHideCursor(false);
      clearTimeout(timer);
      timer = setTimeout(() => setHideCursor(true), 2000);
    };
    window.addEventListener("mousemove", handleMouseMove);
    return () => {
      window.removeEventListener("mousemove", handleMouseMove);
      clearTimeout(timer);
    };
  }, []);

  if (loading) return <TvSkelleton />;
  if (!filteredMenu.length) return <div className="tv-loading">Մենյու չկա։</div>;

  return (
    <div className={`qr-menu-tv-page ${hideCursor ? "hide-cursor" : ""}`}>
      <h1 className="tv-title">
        <img
          src="/icon2.png"
          className="section-icon-2"
          alt="Category Icon"
          onClick={handleLogoClick}
          style={{ cursor: "pointer" }}
        />
        {currentCategory.category}
      </h1>

      <div className="tv-items-container">
        {/* 🗑️ Inter Image բաժինը հեռացված է */}

        {/* Միայն Menu Items */}
        {items.map((item, i) => {
          const cachedImg = imageCache.current?.[item.imageUrl]?.src || item.imageUrl || "";
          const imgProps = getImageProps(cachedImg, i === 0);
          const isLoaded = loadedImages[item.imageUrl];

          return (
            <div key={i} className="tv-item">
              <div className="tv-img-box">
                <img
                  {...imgProps}
                  className={`main-image ${isLoaded ? "loaded fade-in" : ""}`}
                  alt={item.nameEn || item.nameHy || ""}
                />
              </div>

              <div className="tv-item-info">
                <div className="tv-item-name">
                  <div className="tv-item-name-en">{item.nameEn}</div>
                  <div className="tv-item-name-hy">{item.nameHy}</div>
                </div>
                <div className="tv-item-price">
                  <span>{item.price} AMD</span>
                </div>
              </div>
            </div>
          );
        })}
      </div>
    </div>
  );
}